<template>
  <div>
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text text-uppercase dialog-title">
          Xác nhận biên bản thi
          <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel" class="mr-n1" :disabled="loading">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-0">
          <ConfirmAbsentAllTable v-if="all" :documents="importedDocuments" :isImportPreview="true" />
          <ConfirmAbsentTable v-else :documents="importedDocuments" :isImportPreview="true" />
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-btn color="primary" @click="cancel" width="118" :loading="loading" large outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirm" :loading="loading" width="118" class="white--text elevation-0" large
            >Xác nhận</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="progressDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>Đang xử lý</v-card-title>
        <v-card-text>
          <v-progress-linear :value="progress" color="blue darken-4" stream></v-progress-linear>
          <div class="progress-text">{{ formattedProgress }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmAbsentAllTable from './ConfirmAbsentAllTable.vue'
import ConfirmAbsentTable from './ConfirmAbsentTable.vue'
import { ExamMark, AbsentExam } from '../../plugins/api'
export default {
  props: {
    importedDocuments: Array,
    state: Boolean,
    all: Boolean,
    examId: String
  },
  components: {
    ConfirmAbsentTable,
    ConfirmAbsentAllTable
  },

  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      progressDialog: false,
      alertShown: false,
      progress: 0,
      formattedProgress: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    stopLoading() {
      this.loading = false
    },
    async confirm() {
      this.$loading.active = true
      const indexing = ExamMark.updateAbsentExcel(this.examId, { updateDatas: this.importedDocuments })
      if (indexing) {
        await this.getProgress()
      } else {
        this.$alert.error('Lỗi đánh số báo danh')
        this.cancel()
      }
      this.$loading.active = false
    },
    async getProgress() {
      this.progressDialog = true
      this.updateProgress()
      this.progressInterval = setInterval(() => {
        this.updateProgress()
      }, 5000)
    },

    async updateProgress() {
      const progressData = await AbsentExam.fetch({ exam: this.exam })
      const { progress, studentCount, totalStudent, status } = progressData[0]

      this.progress = progress
      console.log(this.progress)
      if (status === 'available') {
        this.progress = 0
        this.alertShown = false
      } else if (status === 'updating') {
        this.progressDialog = true
        if (!this.alertShown) {
          this.$alert.warn('Xin vui lòng đợi để thao tác cũ thực hiện xong')
          this.alertShown = true
        }
        this.formattedProgress = `Đang xử lý ${studentCount}/${totalStudent} học sinh`
      } else if (status === 'finish') {
        this.$loading.active = true
        await AbsentExam.update(progressData[0].id, { status: 'available' })
        this.formattedProgress = ''

        clearInterval(this.progressInterval)
        this.progressDialog = false
        this.$alert.success('Thao tác đánh số trước đã thành công!')
        this.$emit('refresh')
        this.cancel()
      }
    }
  }
}
</script>
